module.exports = __webpack_public_path__ + "media/checkout/BoxConfirmation-ArtofMe-3b2f2dc8.jpg";